/**
 * Hydrates unresolved (`#id`-prefixed or missing) chip labels from a freshly
 * loaded options list. Does NOT overwrite already-resolved labels — the design
 * separates two label sources: (1) `resolveLabel`/lookup for known selections
 * regardless of search state, (2) search-result labels for incidentally-loaded
 * options. The first should win and not be clobbered by the second.
 *
 * Mutates `cfg.labels` in place. Returns whether any placeholder was upgraded
 * so the caller can decide whether to re-render.
 *
 * @param {{
 *   values: string[],
 *   labels: Map<string, string>,
 *   options: ReadonlyArray<import('../../contracts/forms.js').FieldOption>,
 * }} cfg
 * @returns {{ changed: boolean }}
 */
export function resolveChipLabelsFromOptions(cfg) {
  const { values, labels, options } = cfg;
  let changed = false;
  for (const id of values) {
    const current = labels.get(id);
    if (current != null && !current.startsWith('#')) continue;
    const opt = options.find(o => o.value === id);
    if (opt) {
      labels.set(id, opt.label);
      changed = true;
    }
  }
  return { changed };
}
